<template>
  <div class="motivation">
    <div class="header-icons" v-if="status==1 && nominations.length>0">
      <div class="motivation-timer">
        {{ timeToEndText }}
      </div>
      <div class="motivation-nomination">
        <div class="false-icon" v-for="(item, index) in nominations" :key="'nom-' + index">
          <template v-if="Object.keys(item).length === 0">
            <div class="notification-empty-container">
            </div>
          </template>
          <template v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" @click="showInfo([item.title, item.description, item.is_participant])" :class="item.is_participant?'':'cover'">
                                <img class="false-icon-image" :src="item.icon?item.icon:'https://via.placeholder.com/27'" alt="">
                                <div class="notification-container" :class="placeClass([item.position, item.numberOfParticipants])">
                                    <span>{{item.is_participant?item.position:''}}</span>
                                </div>
                            </span>
              </template>
              <span>{{item.title}}</span>
            </v-tooltip>
          </template>

        </div>
        <div class="false-icon descr">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  color="blue darken-2"
                  @click="showInfo([info.title, info.description])"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <span>информация</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <div v-else-if="status==0 || (status==1 && nominations.length==0)">
      <div class="motivation-nomination">
        <div class="false-icon" v-for="{index} in nominations" :key="'slot' - index">
          <div class="notification-empty-container"></div>
        </div>
        <div class="false-icon descr">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  color="orange darken-4"
                  @click="showInfo([null, helpDescription])"
              >
                mdi-alert-outline
              </v-icon>
            </template>
            <span>{{ helpDescription }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <template v-if="status==1 && sliced">
      <div>
        <div class="motivation-nomination">
          <div class="false-icon">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                    color="green darken-4"
                    @click="showResults()"
                >
                  mdi-check-circle-outline
                </v-icon>
              </template>
              <span>Сегодня Мотивити закончилась!</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </template>
    <v-dialog
        v-model="bigInfo"
        max-width="790"
    >
      <v-card>
        <v-card-title class="headline">{{ info.title }}</v-card-title>
        <v-card-text v-if="info.description">
          {{ info.description }}
          <template v-if="info.is_participant == false">
            <hr/>
            <b>Другие мастера прошли обучение и получают хорошие бонусы каждый день.</b>
            <v-btn
                class="mt-2"
                color="#fff"
                @click="sendNominationRequest(info.title)"
                style="color:#00c851;border-radius: .125rem"
            >
              Хочу участвовать!
            </v-btn>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="#00c851"
              @click="bigInfo = false"
              style="color:white;border-radius: .125rem"
          >
            закрыть
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="motivityRequest"
        max-width="790"
    >
      <v-card>
        <v-card-title class="headline">Запрос на участие отправлен!</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="#00c851"
              @click="[motivityRequest = false, bigInfo = false]"
              style="color:white;border-radius: .125rem"
          >
            закрыть
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showWinners"
        max-width="790"
    >
      <v-card>
        <v-card-title class="headline">Результаты мотивити:</v-card-title>
        <v-card-text>
          <p v-for="(winner, index) in winners" :key="'winn' + index">
            В номинации {{ winner.title }} победил {{ winner.fullName }}, мастерская {{ winner.workshop }}. Награда составила {{ winner.reward }} руб.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="#00c851"
              @click="[showWinners = false]"
              style="color:white;border-radius: .125rem"
          >
            закрыть
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "../../plugins/axios-common";

import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      source:'motivation',
      bigInfo: false,
      helpTitle: 'Справка по системе мотивити',
      countDown: 0,
      motivityRequest: false,
      showWinners: false
    }
  },
  computed: {
    ...mapGetters([
      "userData"
    ]),
    info(){
      return {title:'Информация', description: this.$store.state[this.source].helpDescription || ' ' }
    },
    status(){
      return this.$store.state[this.source].status
    },
    helpDescription(){
      return this.$store.state[this.source].helpDescription || ' ' // для теста
    },
    timeToEnd(){
      return this.$store.state[this.source].timeToEnd
    },
    nominations(){
      return this.$store.state[this.source].nominations
    },
    timeToEndText(){
      return ' '
    },
    sliced(){
      return this.$store.state[this.source].sliced
    },
    winners(){
      return this.$store.state[this.source].winners
    }
  },
  watch: {
    timeToEnd(newval){
      console.log('newval',newval)
      if(newval > 0){
        this.countDown = newval * 1000
        //this.startTimer()
      }else {
        this.countDown = 0
      }
    }
  },
  methods: {
    getImage(name) {
      return require(`../../assets/${name}`);
    },
    millisecToTimeStruct (ms) {
      let d, h, m;
      if (isNaN(ms)) {
        return {};
      }
      d = ms / (1000 * 60 * 60 * 24);
      h = (d - ~~d) * 24;
      m = (h - ~~h) * 60;
      h = (h < 10) ? '0' + h.toString() : h.toString()
      m = (m < 10) ? '0' + m.toString() : m.toString()
      return  h + ':' + m
    },
    startTimer() {
      console.log(this.countDown)
      this.countDown = this.countDown - 1
      if(this.countDown>0) setTimeout(this.startTimer(), 1000000)
    },
    showInfo([title, description, is_participant = null]){
      this.info.title = title
      this.info.description = description
      this.bigInfo = true
      this.info.is_participant = is_participant
    },
    placeClass([place,numberOfParticipants]){
      if(place==1) return 'bg-green'
      if(place>numberOfParticipants) return 'bg-yellow'
      if(place==numberOfParticipants) return 'bg-pink'
      return 'bg-pink'
    },
    sendNominationRequest(title) {
      axios.post('/api/cash/motivity/userrequest', {'title':title, 'name': this.userData.name + ' ' + this.userData.surname, 'phone': this.userData.phone, 'email': this.userData.email})
          .then(()=>{
            this.motivityRequest = true
          })
    },
    showResults() {
      this.showWinners = true
    }
  },
};
</script>

<style scoped>
.mo-info-text {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
}
.motiviti-info {
  line-height: 27px;
  margin-right: 4px;
  text-align: center;
  background-color: cornflowerblue;
  border-radius: 25px;
  /* border: 1px solid brown; */
  font-family: 'Goblin One';
}
.motivation-timer {
  font-size: 13px;
}
.cover:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: .125rem;
  background: rgba(255, 255, 255, 0.6);
  z-index: 2;
}
.motivation {
  display: flex;
  justify-content: flex-end;
  width: 273px;
  margin-top: 9px;
}
.motivation-off {
  cursor: pointer;
  width: 100%;
  height: 34px;
  font-size: 12px;
  line-height: 34px;
  border-radius: .125rem;
  overflow: hidden;
  background-color: dimgrey;
  color: white;
  padding: 0 6px;
  text-overflow: ellipsis;
}
.header-icons-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-icons {
  justify-content: center;
  align-items: center;
  display: block;
}
.motivation-nomination {
  justify-content: center;
  align-items: flex-end;
  display: flex;
}
.false-icon {
  min-height: 27px;
  min-width: 27px;
  margin: 4px;
  margin-right: 8px;
  position: relative;
}
.false-icon.descr {
  margin-top: 6px;
}

.false-icon-image {
  border-radius: 6px;
  width: 27px;
  height: 27px;
}
.notification-container {
  position: absolute !important;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: -6px;
  right: -3px;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  z-index: 5;
}
.notification-empty-container {
  position: absolute !important;
  display: flex;
  justify-content: center;
  align-items: center;
  right: -3px;
  border-radius: 6px;
  border: 1px solid #c7c7c7;
  height: 27px;
  width: 27px;
  z-index: 5;
}
.notification-container > span {
  font-size: 13px;
  font-family: 'Istok Web', sans-serif;
}

</style>
